// userContext.js
import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import useAccountAuth from "./hook/useAccountAuth";
import axiosInterceptor from './hook/setupAxiosInterceptors';

const UserContext = createContext();

export const useUserContext = () => {
    return useContext(UserContext);
};

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const accountAuth = useAccountAuth();
    const [counter, setCounter] = useState(0);

    //TODO: Principios SOLID la responsabilidad de carga la debe tener otro provider
    const uploadProgressFnc = (progress) => {
        setUploadProgress(progress);
    }

    const [showLoader, setShowLoader] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0); // Para rastrear el progreso de carga
    const interceptorunit = axiosInterceptor(setShowLoader, uploadProgressFnc);  
    

    useEffect(() => {
        let intervalId;
        if (showLoader) {
          intervalId = setInterval(() => {
            setCounter((prevCounter) => (prevCounter === 20 ? 0 : prevCounter + 1));
            setUploadProgress((prevCounter) => (prevCounter === 20 ? 0 : prevCounter + 1));
          }, 300);
        }
        return () => {
          if (intervalId) clearInterval(intervalId);
        };
      }, [showLoader]);
    
      const startLoader = useCallback(() => {
        setShowLoader(true);
      }, []);
    
      const stopLoader = useCallback(() => {
        setShowLoader(false);
        setCounter(0);
    }, []);

    return (
        <UserContext.Provider value={{ user, setUser, showLoader, uploadProgress, startLoader, stopLoader }}>
            {children}
        </UserContext.Provider>
    );
};
